const $ = require("jquery")
const NewsSends = document
    .getElementsByClassName('newsletter_submit')
var formulario = document
    .getElementById('formNews')
const auth = require('../views/components/auth/auth.script');
const start = async function() {
    Array
        .from(NewsSends)
        .forEach((NewsSend, i) => {
            console.log('NewsSends', NewsSend)
            NewsSend
                .addEventListener('click', (e) => sendNews())
        });

    async function sendNews() {
        document.getElementsByClassName("newsletter_submit")[0].classList.add("disabled")
        var formulario = document.getElementById("formNews");
        var name = formulario.first_name;
        var email = formulario.email;
        var url_retorno = window.location.href + '#newsletter-sucesso';


        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${await auth()}`);
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                name: name.value,
                email: email.value
            })
        };

        let newsletterAPI = await fetch("http://localhost:4040/thank-you-me/api/newsletter", requestOptions)


        await newsletterAPI.json()

        document.getElementsByClassName("newsletter_submit")[0].classList.remove("disabled")
        if (name.value == "") {
            $('#first_name_news').addClass('error');
            return false;
        } else if (email.value == "") {
            $('#email_news').addClass('error');
            return false;
        } else if (email.value.indexOf("@") == -1 || email.value.indexOf(".") == -1) {
            $('#email_news').addClass('error');
            return false;
        } else {
            $('#formNews input[name="retURL"]').val(url_retorno);
            formulario.requestSubmit();
            //window.location.href =  window.location.href + '#newsletter-sucesso';
        }
    }


    //funcoes newsletter
    $('#newsletter_footer .abre-news').on('click', function() {
        $('#newsletter_footer .box').removeClass('active');
        $('#newsletter_footer .box-form').addClass('active');
    })

    $('#newsletter_footer .fechar-form').on('click', function() {
        $('#newsletter_footer .box-form').removeClass('active');
        $('#newsletter_footer .box-chamada').addClass('active');
    })
    $('#newsletter_footer .fecha-news').on('click', function() {
        $('#first_name_news').val('');
        $('#email_news').val('');
        $('#newsletter_footer .box').removeClass('active');
        $('#newsletter_footer .box-chamada').addClass('active');
        window.history.back();
    })

    $('.formNews input').on('focusout', function() {
        if ($(this).val() != '') {
            $(this).removeClass('error')
            $(this).addClass('filled')
        } else {
            $(this).removeClass('filled')
        }
    })

    var url_sucesso = window.location.href
    url_sucesso = url_sucesso.split("#").pop();

    if (url_sucesso == 'newsletter-sucesso') {
        $('#newsletter_footer .box').removeClass('active');
        $('#newsletter-sucesso').addClass('active');
        $('html, body').animate({
            scrollTop: $('footer').offset().top - 100
        }, 500);
    }

}

module.exports = {
    start: start
};
